<div class="layout-column full-height">
  <div *ngIf="isRow" class="layout-row layout-align-start-center">
    <div class="layout-row layout-align-start-center">
      <app-bringoz-date-picker class="margin-right-10"
                               [date]="timeConfig.from.date"
                               [isDisabled]="timeOnly"
                               [placeholder]="fromPlaceholder"
                               (onChange)="onFromDateChange($event)">
      </app-bringoz-date-picker>

      <div class="layout-row layout-align-start-center">
        <div *ngIf="isInvalidDates" class="margin-right-5">
          <bringoz-icon iconName="error" fill="#f44336" [ngbTooltip]="'Invalid date range' | translate" placement="top"
                        openDelay="300"></bringoz-icon>
        </div>
        <app-bringoz-time-select *ngIf="!dateOnly"
                                 [selectedTime]="timeConfig.from.value"
                                 [ticksInMinutes]="ticks"
                                 [max]="timeConfig.to.value"
                                 (onSelect)="onFromTimeChange($event)">
        </app-bringoz-time-select>
      </div>

      <app-bringoz-time-zone-display class="margin-left-5"
                                     [timeZoneId]="zoneId"
                                     [notBefore]="timeConfig.from.value">
      </app-bringoz-time-zone-display>
    </div>

    <div class="layout-row layout-align-start-center">
      <app-bringoz-date-picker class="margin-right-10"
                               [date]="timeConfig.to.date"
                               [minDate]="timeConfig.from.date"
                               [isDisabled]="timeOnly"
                               [placeholder]="toPlaceholder"
                               (onChange)="onToDateChange($event)">
      </app-bringoz-date-picker>

      <div class="layout-row layout-align-start-center">
        <div *ngIf="isInvalidDates" class="margin-right-5">
          <bringoz-icon iconName="error" fill="#f44336" [ngbTooltip]="'Invalid date range' | translate" placement="top"
                        openDelay="300"></bringoz-icon>
        </div>
        <app-bringoz-time-select *ngIf="!dateOnly"
                                 [selectedTime]="timeConfig.to.value"
                                 [min]="timeConfig.from.value"
                                 [ticksInMinutes]="ticks"
                                 (onSelect)="onToTimeChange($event)">
        </app-bringoz-time-select>
      </div>

      <app-bringoz-time-zone-display class="margin-left-5"
                                     [timeZoneId]="zoneId"
                                     [notBefore]="timeConfig.to.value">
      </app-bringoz-time-zone-display>
    </div>
  </div>

  <div *ngIf="!isRow" class="layout-column">
    <div class="layout-row layout-align-start-center">
      <div *ngIf="!fromPlaceholder">
        <span class="br-body-2">{{ 'Start Time' | translate }}</span>
      </div>

      <div class="date-time-controls">
        <app-bringoz-date-picker class="margin-right-10"
                                 [date]="timeConfig.from.date"
                                 [isDisabled]="timeOnly"
                                 [placeholder]="fromPlaceholder"
                                 (onChange)="onFromDateChange($event)">
        </app-bringoz-date-picker>

        <div class="layout-row layout-align-start-center">
          <div *ngIf="isInvalidDates" class="margin-right-5">
            <bringoz-icon iconName="error" fill="#f44336" [ngbTooltip]="'Invalid date range' | translate"
                          placement="top" openDelay="300"></bringoz-icon>
          </div>
          <app-bringoz-time-select *ngIf="!dateOnly"
                                   [selectedTime]="timeConfig.from.value"
                                   [ticksInMinutes]="ticks"
                                   [max]="timeConfig.to.value"
                                   (onSelect)="onFromTimeChange($event)">
          </app-bringoz-time-select>

          <app-bringoz-time-zone-display [timeZoneId]="zoneId"
                                         [notBefore]="timeConfig.from.value">
          </app-bringoz-time-zone-display>
        </div>
      </div>
    </div>

    <div class="layout-row layout-align-start-center margin-top-10">
      <div *ngIf="!toPlaceholder" class="label">
        <span class="br-body-2">{{ 'End Time' | translate }}</span>
      </div>

      <div class="date-time-controls">
        <app-bringoz-date-picker class="margin-right-10"
                                 [date]="timeConfig.to.date"
                                 [minDate]="timeConfig.from.date"
                                 [isDisabled]="timeOnly"
                                 [placeholder]="toPlaceholder"
                                 (onChange)="onToDateChange($event)">
        </app-bringoz-date-picker>

        <div class="time-section">
          <div *ngIf="isInvalidDates" class="margin-right-5">
            <bringoz-icon iconName="error" fill="#f44336" [ngbTooltip]="'Invalid date range' | translate"
                          placement="top" openDelay="300"></bringoz-icon>
          </div>
          <app-bringoz-time-select *ngIf="!dateOnly"
                                   [selectedTime]="timeConfig.to.value"
                                   [min]="timeConfig.from.value"
                                   [ticksInMinutes]="ticks"
                                   (onSelect)="onToTimeChange($event)">
          </app-bringoz-time-select>

          <app-bringoz-time-zone-display [timeZoneId]="zoneId"
                                         [notBefore]="timeConfig.to.value">
          </app-bringoz-time-zone-display>
        </div>
      </div>
    </div>
  </div>
</div>
